import { useCallback } from "react";

import { keywordGroupsQueryClient } from "app/services/keyword-groups";
import { translate } from "app/filters/i18nFilter";
import { SINGLE } from "app/pages/activation/components/Topics/constants";
import { PLURAL_SUCCESS_TOAST, SINGULAR_SUCCESS_TOAST } from "app/pages/activation/components/Topics/texts";
import type { CreationFlow, ShortTopicSchema } from "app/pages/activation/components/Topics/types";
import { TopicSorting } from "app/pages/activation/components/Topics/types";

import { useToasts } from "../../helpers/useToasts";

type UseHandleSuccessCreationSchema = {
    onClose: () => void;
    onSort: (item: { id: TopicSorting }) => void;
};

export const useHandleSuccessCreation = ({ onClose, onSort }: UseHandleSuccessCreationSchema) => {
    const { showSuccessToast } = useToasts();

    return useCallback(
        async (created: ShortTopicSchema[], from: CreationFlow) => {
            const createdTopicsNames = created.map((t) => `${t.name}`);
            const createdTopicsStr = createdTopicsNames.join(", ");
            const toast = createdTopicsNames.length > SINGLE ? PLURAL_SUCCESS_TOAST : SINGULAR_SUCCESS_TOAST;

            await keywordGroupsQueryClient.invalidateAll();

            showSuccessToast(translate(toast, { name: createdTopicsStr }));

            onSort({ id: TopicSorting.MostRecent });

            onClose();

            return { createdTopicsStr, from };
        },
        [onClose, onSort],
    );
};
